@use 'src/styles/config.module' as *;

.headerControls {
  display: flex;
  justify-content: flex-end;
}

.footerControls {
  display: flex;
  justify-content: space-between;
  padding: 2rem;
  .rightSide {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    :global {
      .MuiButton-root {
        margin-left: 1rem;
      }
    }
  }
}

.formTabs {
  padding: 0 0 1rem;
}

.formWrapper {
  display: flex;
  flex-direction: column;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.1);
  border-radius: 0.4rem;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.5rem 2rem 0.9rem;
}
.content {
  background: #fff;
  padding: 2.4rem 2rem;
  min-width: 0;
  flex-grow: 1;
}

.subHeader {
  padding: 0 2rem;
  min-height: 1.6rem;
}
.error {
  color: $color-red;
}
